<template>
  <b-modal
    id="gnv-massa-benefits-modal"
    v-model="isVisible"
    centered
    hide-header
    hide-header-close
    hide-footer
    :no-close-on-backdrop="false"
    :no-close-on-esc="true"
    content-class="gnv-flow-modal-content"
    body-class="gnv-flow-modal-body p-0"
  >
    <div class="gnv-flow-modal gnv-flow-modal--dark-theme">
      <div class="gnv-flow-modal__top-bar" />

      <div class="gnv-flow-modal__inner">
        <h4 class="gnv-flow-modal__title">
          {{ title }}
        </h4>

        <p class="gnv-flow-modal__subtitle">
          {{ description }}
        </p>

        <ul class="gnv-flow-modal__list">
          <li v-for="(benefit, index) in benefits" :key="index">
            <span class="gnv-flow-modal__check">✓</span>
            {{ benefit }}
          </li>
        </ul>

        <p class="gnv-flow-modal__cta">
          {{ ctaText }}
        </p>

        <div class="gnv-flow-modal__actions">
          <button
            type="button"
            class="gnv-flow-modal__btn gnv-flow-modal__btn--primary"
            :style="gnvModalPrimaryButtonStyle"
            @click="confirmWithPlan"
          >
            {{ confirmWithPlanText }}
          </button>
          <button
            type="button"
            class="gnv-flow-modal__btn"
            :style="gnvModalSecondaryButtonStyle"
            @click="confirmWithoutPlan"
          >
            {{ confirmWithoutPlanText }}
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import gnvModalMixin from '@/mixins/gnvModalMixin'

export default {
  name: 'GnvMassaBenefitsModal',
  mixins: [gnvModalMixin],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },
    title() {
      return this.gnvFlow.benefitsModalTitle || this.$t('gnv.benefitsTitle')
    },
    description() {
      return this.gnvFlow.benefitsModalDescription || this.$t('gnv.benefitsDescription')
    },
    ctaText() {
      return this.gnvFlow.benefitsModalCta || this.$t('gnv.benefitsCta')
    },
    confirmWithPlanText() {
      return this.gnvFlow.benefitsConfirmWithPlanText || this.$t('gnv.benefitsConfirmWithPlan')
    },
    confirmWithoutPlanText() {
      return this.gnvFlow.benefitsConfirmWithoutPlanText || this.$t('gnv.benefitsConfirmWithoutPlan')
    },
    benefits() {
      if (this.gnvFlow.benefits) return this.gnvFlow.benefits
      return this.$i18n.messages[this.$i18n.locale].gnv.benefits
    },
  },
  methods: {
    confirmWithPlan() {
      this.$emit('confirm-with-plan')
      this.isVisible = false
    },
    confirmWithoutPlan() {
      this.$emit('confirm-without-plan')
      this.isVisible = false
    },
  },
}
</script>
